import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';

const CONSENT_KEY = 'videovault_analytics_consent';
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-GXWD5E9K1P';

const loadGoogleAnalytics = () => {
  if (document.querySelector(`script[data-videovault-ga="${GA_ID}"]`)) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.dataset.videovaultGa = GA_ID;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { anonymize_ip: true });
};

const CookieConsent = () => {
  const [choice, setChoice] = useState(() => window.localStorage.getItem(CONSENT_KEY));

  useEffect(() => {
    if (choice === 'accepted') loadGoogleAnalytics();
  }, [choice]);

  const saveChoice = (value) => {
    window.localStorage.setItem(CONSENT_KEY, value);
    setChoice(value);
  };

  if (choice) return null;

  return (
    <aside
      className="fixed inset-x-4 bottom-4 z-50 mx-auto max-w-3xl rounded-lg border-2 border-black bg-white p-5 shadow-2xl"
      aria-label="Preferencias de analítica"
    >
      <p className="font-semibold text-black">Preferencias de privacidad</p>
      <p className="mt-2 text-sm leading-relaxed text-gray-700">
        Usamos almacenamiento local necesario para el funcionamiento. Con tu permiso,
        Google Analytics medirá visitas y rendimiento. Podés aceptar o rechazar sin
        afectar las descargas. La publicidad administra su consentimiento por separado.
      </p>
      <div className="mt-4 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <Button variant="outline" onClick={() => saveChoice('rejected')}>
          Rechazar analítica
        </Button>
        <Button onClick={() => saveChoice('accepted')}>
          Aceptar analítica
        </Button>
      </div>
    </aside>
  );
};

export default CookieConsent;
